import TagInput from '@/templates/tag-input/tag-input.template';
import IRootPageLink from '@/types/IRootPageLink';
import {
	AccordionButton,
	AccordionItem,
	AccordionPanel,
	Box,
	FormControl,
	FormErrorMessage,
	FormLabel,
	IconButton,
	Input,
	Text,
	Tooltip,
} from '@chakra-ui/react';
import { FcLink } from 'react-icons/fc';
import { VscTrash } from 'react-icons/vsc';
import { useAccordionLink } from './accordion-link.controller';

interface ILinkProps {
	link: IRootPageLink;
	isLoading: boolean;
	onChange: (q: IRootPageLink) => void;
	onDelete: (q: IRootPageLink) => void;
}

export default function AccordionLink(props: ILinkProps) {
	const { t, form, tagForm, registerSubmitOnBlur } = useAccordionLink(props);

	return (
		<AccordionItem>
			<Box display="grid" gridTemplateColumns="1fr auto" overflow="hidden" alignItems="center">
				<AccordionButton
					display="grid"
					gridTemplateColumns="auto 1fr"
					overflow="hidden"
					textOverflow="ellipsis"
					whiteSpace="nowrap"
				>
					<FcLink />
					<Text ml="2" mr="auto" pr="2" textAlign="left" overflow="hidden" textOverflow="ellipsis" maxW="100%">
						{props.link.name}
					</Text>
				</AccordionButton>
				<Tooltip label={t('Delete')}>
					<IconButton
						mx="2"
						borderRadius="50%"
						aria-label={t('Delete')}
						icon={<VscTrash />}
						colorScheme="red"
						isLoading={props.isLoading}
						onClick={() => props.onDelete({ ...props.link })}
						size="xs"
						variant="outline"
					/>
				</Tooltip>
			</Box>
			<AccordionPanel pb={10}>
				<FormControl isInvalid={!!form.formState.errors.link} id="link">
					<FormLabel>{t('URL')}</FormLabel>
					<Input
						disabled={props.isLoading}
						type="url"
						{...registerSubmitOnBlur('link')}
						variant="filled"
						isDisabled={props.isLoading}
						placeholder="https://example.com/"
					/>

					<FormErrorMessage>{form.formState.errors.link?.message}</FormErrorMessage>
				</FormControl>

				<FormControl mt="3" id="name">
					<FormLabel>{t('Visible text')}</FormLabel>
					<Input
						disabled={props.isLoading}
						{...registerSubmitOnBlur('name')}
						type="text"
						variant="filled"
						isDisabled={props.isLoading}
						placeholder={t('Write a visible text for your link here')}
					/>
				</FormControl>

				<FormControl mt="3" id="description">
					<FormLabel>{t('Description')}</FormLabel>
					<Input
						disabled={props.isLoading}
						{...registerSubmitOnBlur('description')}
						variant="filled"
						isDisabled={props.isLoading}
						placeholder={t('Write a description for your link here')}
					/>
				</FormControl>

				<FormControl mt="3" id="imageUrl">
					<FormLabel>{t('Image')}</FormLabel>
					<Input
						disabled={props.isLoading}
						{...registerSubmitOnBlur('imageUrl')}
						variant="filled"
						isDisabled={props.isLoading}
						placeholder={t('Paste a link to an image here')}
					/>
				</FormControl>

				<TagInput
					isLoading={props.isLoading}
					defaultValue={props.link.tags}
					onChange={(tags) => {
						props.onChange({ ...props.link, tags });
					}}
				/>
			</AccordionPanel>
		</AccordionItem>
	);
}
